import { ArrowDropDown } from '@mui/icons-material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { Box, Button, Menu, MenuItem } from '@mui/material'
import { DIALOG_ID } from 'components/Dialog/constant'
import PopoverJoinNowCC from 'components/Popover/PopoverJoinNowCC'
import PopoverMeetingCC from 'components/Popover/PopoverMeetingCC'
import { PATH_ROOT } from 'constants/api'
import { useMenuCC } from 'hooks'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import theme from 'theme'
import { setOpenDialogCC } from 'utils/helpers'
import DialogMeetingNow from './DialogMeetingNow'

const CTH = 'cth'
const MEET = 'meet'

const BreadcrumbsMeeting = () => {
    const { t } = useTranslation()
    const { open, anchorEl, setAnchorEl } = useMenuCC()
    const navigate = useNavigate()
    const handleClose = _ => setAnchorEl(false)
    const handleOpenDialogMeetingNow = _ => setOpenDialogCC({ id: DIALOG_ID.MEETING_NOW })
    const handleScheduleMeeting = _ => navigate(`${PATH_ROOT}/manager-meeting/schedule-meeting/create`)
    const handleOpenDialogJoinMeeting = (type) => setOpenDialogCC({ id: DIALOG_ID.JOIN_MEETING, props: { type: type } })

    return (
        <Box sx={{ display: 'flex', columnGap: 2 }}>
            <PopoverMeetingCC type={CTH} />
            <PopoverMeetingCC type={MEET} />
            <PopoverJoinNowCC />
            <DialogMeetingNow />
            {<Button onClick={handleScheduleMeeting} sx={{ display: { xs: 'none', sm: 'flex' } }} startIcon={<AddCircleOutlineIcon sx={{ color: 'white', width: theme.spacing(2.5), height: theme.spacing(2.5) }} />}>{t('mnMeeting.scheduleMeeting')}</Button>}
            <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
                <Button
                    variant='text'
                    id="meet-more"
                    aria-controls={open ? 'meet-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    endIcon={<ArrowDropDown />}
                >
                    {t('actions.option')}
                </Button>
                <Menu
                    id="meet-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        'aria-labelledby': 'meet-more',
                    }}
                >
                    <MenuItem onClick={() => handleOpenDialogJoinMeeting(CTH)}>{t('mnMeeting.cth')}</MenuItem>
                    <MenuItem onClick={() => handleOpenDialogJoinMeeting(MEET)}>{t('manageMeeting:mnMeeting.joinId')}</MenuItem>
                    <MenuItem sx={{ display: { xs: 'block', sm: 'none' } }} onClick={handleOpenDialogMeetingNow}>{t('manageMeeting:mnMeeting.joinNow')}</MenuItem>
                    <MenuItem sx={{ display: { xs: 'block', sm: 'none' } }} onClick={handleScheduleMeeting}>{t('manageMeeting:mnMeeting.scheduleMeeting')}</MenuItem>
                </Menu>
            </Box>
        </Box>
    )
}

export default BreadcrumbsMeeting